import LoginForm from "features/Auth";

const LoginPage = () => {
  return (
    <div className="container">
      <LoginForm />
    </div>
  );
};

export default LoginPage;
